import { render, staticRenderFns } from "./AcceptableItems.vue?vue&type=template&id=b62cf6aa&scoped=true"
import script from "./AcceptableItems.vue?vue&type=script&lang=js"
export * from "./AcceptableItems.vue?vue&type=script&lang=js"
import style0 from "./AcceptableItems.vue?vue&type=style&index=0&id=b62cf6aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b62cf6aa",
  null
  
)

export default component.exports